export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('fr-FR').format(value as number)
}

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value)
}

export const roundFloat = (value: number): number => {
  return Math.round(value * 100) / 100
}
